import { Component, OnChanges, Input, SimpleChanges, OnInit } from '@angular/core';
import { CfetBaseComponent } from '../../cfet-core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-progress-tracker',
    templateUrl: './progress-tracker.component.html',
    styleUrls: ['./progress-tracker.component.scss'],
    standalone: false
})
export class ProgressTrackerComponent extends CfetBaseComponent implements OnChanges, OnInit {
  @Input() stepOneIcon: boolean;
  @Input() stepOneTickIcon: boolean;
  @Input() stepTwoInformationpage: boolean;
  @Input() stepOneRoleDone: boolean;
  @Input() stepOneDone: boolean;
  @Input() verificationType: 'self' | 'agency' | null = null;
  @Input() stepTwoProfileDone: boolean;
  @Input() stepTwoDone: boolean;
  @Input() stepThreeSelected: boolean;
  @Input() progressTrackerStatus: any;
  @Input() stepThreeCreatePwdPage: boolean;
  stepOneSelected: boolean;
  disableStep: boolean;
  isAuthPage = false;
  currentRoute: string;
  stepOneEligibilitypage = true;
  showEligibilityHeading = true;
  showActivationHeading = false;
  showInfoSubHeading = false;
  showInfoHeading = false;
  underLineStep1 = true;
  stepTwoIcon = true;
  stepTwoTickIcon = false;
  stepTwoSelected = false;
  underLineStep2 = false;
  isMobile: boolean;
  stepThreeConfirmpage: boolean;
  stepThreeIcon = true;
  stepThreeTickIcon = false;
  underLineStep3 = false;
  eligibilitySection = true;
  informationSection = true;
  activationSection = true;
  showEligibility = true;
  showInformation = false;
  showActivation = false;
  roleSection = true;
  eligibility_heading: string;
  eligibility_subheading: string;
  eligibility_subheading1: string;
  information_heading: string

  constructor(private router: Router) {
    super();
    this.eligibility_heading =
      this.cfetLabels.cfet_customer_eligibility.utf_heading;

    this.eligibility_subheading =
      this.cfetLabels.cfet_customer_eligibility.self_eligibility;

    this.eligibility_subheading1 = '';

    this.information_heading =
      this.cfetLabels.cfet_customer_information.utf_heading;
    console.log(this.router.url);
    if (this.router.url.indexOf('/information') > -1) {
      this.showEligibilityHeading = false;
      this.showActivationHeading = false;
      this.showInfoHeading = true;
    }
    if ((this.router.url.indexOf('/utf-auth-page') > -1) || (this.router.url.indexOf('/affiliationCode') > -1) ||
      (this.router.url.indexOf('/utf-syncing-info') > -1)) {
      this.isAuthPage = true;
    }
    //     if (sessionStorage.getItem('orgDetailInfo') && Object.keys(sessionStorage.getItem('orgDetailInfo')).length !== 0) {
    //       this.eligibility_heading = this.cfetLabels.cfet_customer_eligibility.utf_agency_heading;
    //       this.eligibility_subheading = this.cfetLabels.cfet_customer_eligibility.Agency_eligibility;
    //       this.eligibility_subheading1 = this.cfetLabels.cfet_customer_eligibility.Agency_verified_text;
    //       this.information_heading = this.cfetLabels.cfet_customer_information.utf_agency_heading;
    //     }
    //     else {
    //       this.eligibility_heading = this.cfetLabels.cfet_customer_eligibility.utf_heading;
    //       this.eligibility_subheading = this.cfetLabels.cfet_customer_eligibility.self_eligibility;
    //       this.eligibility_subheading1 = this.cfetLabels.cfet_customer_eligibility.self_eligibility_text;
    //       this.information_heading = this.cfetLabels.cfet_customer_information.utf_heading;
    //     }
    //     if (this.verificationType === 'agency') {

    //   this.eligibility_heading = this.cfetLabels.cfet_customer_eligibility.utf_agency_heading;

    // } else if (this.verificationType === 'self') {

    //   this.eligibility_heading = this.cfetLabels.cfet_customer_eligibility.utf_heading;

    // } else {

    //   // 🔥 Neutral state
    //   this.eligibility_heading = this.cfetLabels.cfet_customer_eligibility.utf_heading;
    //   this.eligibility_subheading1 = '';
    // }
  }

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit() {
    const storedType = sessionStorage.getItem('verificationType');
    if (storedType === 'agency') {
      this.verificationType = 'agency';
      this.eligibility_heading =
        this.cfetLabels.cfet_customer_eligibility.utf_agency_heading;
      this.eligibility_subheading =
        this.cfetLabels.cfet_customer_eligibility.Agency_eligibility;
      this.eligibility_subheading1 =
        this.cfetLabels.cfet_customer_eligibility.Agency_verified_text;
    }
    if (storedType === 'self') {
      this.verificationType = 'self';
      this.eligibility_heading =
        this.cfetLabels.cfet_customer_eligibility.utf_heading;
      this.eligibility_subheading =
        this.cfetLabels.cfet_customer_eligibility.self_eligibility;
      this.eligibility_subheading1 =
        this.cfetLabels.cfet_customer_eligibility.self_eligibility_text;
    }
  }
  ngOnChanges(changes: SimpleChanges) {
    console.log('STATUS:', this.progressTrackerStatus);
    if (this.stepOneDone && !this.stepTwoDone) {
      this.showInfoHeading = true;
      this.showEligibilityHeading = false;
    }
    if (this.stepTwoDone) {
      this.showActivationHeading = true;
      this.showInfoHeading = false;
    }
    if (changes['verificationType']) {

      if (this.verificationType === 'agency') {

        this.eligibility_heading =
          this.cfetLabels.cfet_customer_eligibility.utf_agency_heading;

        this.eligibility_subheading =
          this.cfetLabels.cfet_customer_eligibility.Agency_eligibility;

        this.eligibility_subheading1 =
          this.cfetLabels.cfet_customer_eligibility.Agency_verified_text;

      } else if (this.verificationType === 'self') {

        this.eligibility_heading =
          this.cfetLabels.cfet_customer_eligibility.utf_heading;

        this.eligibility_subheading =
          this.cfetLabels.cfet_customer_eligibility.self_eligibility;

        this.eligibility_subheading1 =
          this.cfetLabels.cfet_customer_eligibility.self_eligibility_text;

      } else {

        // ✅ Neutral default
        this.eligibility_heading =
          this.cfetLabels.cfet_customer_eligibility.utf_heading;

        this.eligibility_subheading =
          this.cfetLabels.cfet_customer_eligibility.self_eligibility;

        this.eligibility_subheading1 = '';
      }
    }
    // if (this.stepOneDone) {
    //   this.stepOneIcon = false;
    //   this.stepOneTickIcon = true;
    //   this.underLineStep1 = false;
    // }

    // if (this.stepTwoInformationpage) {
    //   this.stepOneIcon = false;
    //   this.stepOneTickIcon = true;
    //   this.underLineStep1 = false;
    //   this.underLineStep2 = this.stepTwoSelected;
    //   this.stepOneRoleDone = true;
    //   this.stepTwoSelected = this.progressTrackerStatus === 'profileInfo';
    //   // Instant Verification step
    //   if (this.progressTrackerStatus === 'verified') {
    //     this.stepTwoProfileDone = true;
    //   }
    // }
    if (this.progressTrackerStatus === 'Activation') {
      this.stepTwoDone = true;
    }
    if (this.progressTrackerStatus === 'createPwd') {
      this.stepThreeCreatePwdPage = true;
    }
    if (this.stepTwoDone) {
      this.stepTwoTickIcon = true;
      this.stepTwoIcon = false;
      this.underLineStep1 = false;
      this.underLineStep2 = false;
      this.underLineStep3 = true;
      this.showActivationHeading = true;
      this.showInfoHeading = false;
      this.stepTwoDone = true;
      this.stepTwoSelected = false;
      this.stepThreeSelected = true;
      this.stepTwoProfileDone = true;
      this.stepOneSelected = this.progressTrackerStatus === 'roleDetails';
      this.stepTwoSelected = this.progressTrackerStatus === 'profileInfo';
      this.stepThreeSelected =
      this.progressTrackerStatus === 'createPwd' ||
      this.progressTrackerStatus === 'confirmOtppage';
      this.underLineStep1 = this.stepOneSelected;
      this.underLineStep2 = this.stepTwoSelected;
      this.underLineStep3 = this.stepThreeSelected;
      this.stepTwoProfileDone = true;
      this.progressTrackerInfo();
    }
    else {
      this.windowResize();
    }
  }

  progressTrackerInfo() {

    if (navigator.userAgent.match(/Android/i)
      || navigator.userAgent.match(/webOS/i)
      || navigator.userAgent.match(/iPhone/i)
      || navigator.userAgent.match(/iPod/i)
      || navigator.userAgent.match(/BlackBerry/i)
      || navigator.userAgent.match(/Windows Phone/i)
      || navigator.userAgent.match(/iPad/i) && (screen.availHeight > screen.availWidth)) {
      if (this.showEligibilityHeading) {
        // On Eligibility step for mobiles
        this.showEligibility = true;
        this.showActivation = false;
        this.showInformation = false;
        this.underLineStep1 = false;
      }
      if (this.showInfoHeading) {
        // On information step for mobiles
        this.showEligibility = false;
        this.showActivation = false;
        this.showInformation = true;
        this.underLineStep2 = false;
        // Make the first step not bold/highlighted if the user is on second or third step
        if (this.progressTrackerStatus === 'profileInfo' || this.progressTrackerStatus === 'verified') {
          this.isMobile = false;
        } else if (this.progressTrackerStatus === 'registration') {
          this.isMobile = true;
        } else {
          this.isMobile = false;
        }
      }
      if (this.showActivationHeading) {
        // On profile step for mobiles
        this.showEligibility = false;
        this.showActivation = true;
        this.showInformation = false;
        this.underLineStep3 = false;
      }
    }
  }
  windowResize() {
    if (window.innerWidth >= 768) {
    } else {
      if (this.showEligibilityHeading) {
        this.showEligibility = true;
        this.showActivation = false;
        this.showInformation = false;
      } else if (this.showInfoHeading) {
        this.showInformation = true;
        this.showEligibility = false;
        this.showActivation = false;
      } else if (this.showActivationHeading) {
        this.showActivation = true;
        this.showInformation = false;
        this.showEligibility = false;
      }
    }
  }

  onResize(event) {
    if (event && event.type === 'resize') {
      if (screen.availHeight < screen.availWidth || screen.availHeight > screen.availWidth) {
        this.windowResize();
      }
    }
  }
}